import React, { Component } from 'react';
import SelectBox from '../component/Select.js';
import Input from '../component/Input.js';
import axios from 'axios';
import {path} from './routes.js';
import Modal from 'react-modal';
import loader from '../asset/img/loader.gif';
import Validation from './Validation.js';

export default class ManageDepartments extends Component {
	constructor(props){
		super(props);
		this.state ={createDepartment:'',
									newDepartment:'Select',
									managerChoice:'Select',
									department:'',
									manager:'',
									employees:[],
									departmentMembers:[],
									modalIsOpen:false,
									loading:false,
									newManager:false,
									onlyDepartment:false,
									employeeToMove:{},
									modalPrompt:''
								};
		this.handleInput = this.handleInput.bind(this);
		this.createDepartment = this.createDepartment.bind(this);
		this.moveEmployee = this.moveEmployee.bind(this);
		this.handleButtonClick = this.handleButtonClick.bind(this);
		this.closeModal = this.closeModal.bind(this);
		this.newManager = this.newManager.bind(this);
	}

	moveEmployee(){ //method for moving employee from one department to another department
		if(this.state.newDepartment !== 'Select'){ //make sure a new department is selected
			document.getElementById("newDeptSpan").innerHTML="*";
			this.setState({loading:true});
			let employeeToMove = this.state.employeeToMove;
			axios({
				method:'post',
				url:path,
				headers:{'Content-Type':'application/json'},
				data:{endpoint:'create',table:'department',misc:'switch',firstID:employeeToMove.userID,name:this.state.newDepartment,status:this.state.department}
			}).then((response)=>{
				this.setState({modalPrompt:'Employee department successfully changed!',employeeToMove:'',newDepartment:'Select',loading:false});
				this.props.getDepartments();
			});
		}else{
			document.getElementById("newDeptSpan").innerHTML="*Required";
		}
	}

	newManager(){ //method for promoting someone to manager of a department
		if(!this.state.onlyDepartment || (this.state.newDepartment && this.state.newDepartment !== "Select")){ //if they are manager of another department, or they are not a manager of another department but a second department has been selected for them, begin
			let newManagerID;
			this.setState({loading:true});
			for(let i=0;i<this.props.employeeList.length;i++){ //get userID for the new manager
				if(this.state.manager === this.props.employeeList[i].name){
					newManagerID = this.props.employeeList[i].userID;
					break;
				}
			}
			let department = this.state.department.toLowerCase();
			let status = department.indexOf("asm") === -1?"manager":"asm_regional"; //promote them to either manager or asm_regional depending on whether or not the department is an asm department 
			axios({ //update usertype
				method:'post',
				url:path,
				headers:{'Content-Type':'application/json'},
				data:{endpoint:'create',table:'users',misc:'type',firstID:newManagerID,status:status,name:this.state.department}
			}).then((response)=>{
				if(this.state.newDepartment){ //if the department is brand new, create the department
					axios({
						method:'post',
						url:path,
						headers:{'Content-Type':'application/json'},
						data:{endpoint:'create',table:'department',misc:'switch',firstID:newManagerID,name:this.state.newDepartment,status:"add_dept"}
					}).then((response)=>{
						this.setState({newDepartment:'Select',onlyDepartment:false,loading:false,newManager:false,modalPrompt:'Manager successfully changed!'});
						this.props.getDepartments();
					})
				}else{
					this.setState({loading:false,newManager:false,modalPrompt:'Manager successfully changed!'});
					this.props.getDepartments();
				}
			});
		}
	}

	closeModal(){ //method to close the modal
		this.setState({modalIsOpen:false,modalPrompt:''});
	}

	handleButtonClick(e){ //handles button click for choosing to move an employee to another department
		this.setState({modalIsOpen:true,employeeToMove:{userID:e.target.id,name:e.target.name}});
	}

	handleInput(identity,value){ //method for handling user input
		const theState = {};
		if(identity === "department"){ //handle department selection from department dropdown menu
			for(let i=0;i<this.props.departmentInfo.length;i++){
				if(this.props.departmentInfo[i].department === value){
					theState['manager'] = this.props.departmentInfo[i].manager.name;
					theState['departmentMembers'] = this.props.departmentInfo[i].employees;
					break;
				}
			}
		}
		if(identity === "manager"){ //handle new manager selection from manager dropdown menu
			let departments = 0;
			let currentMember = false;
			theState['newManager'] = true;
			theState['modalIsOpen'] = true;
			for(let j=0;j<this.state.departmentMembers.length;j++){ //check to see if new manager is part of current department
				if(this.state.departmentMembers[j].name === value){
					currentMember = true;
					this.props.employeeList.forEach((employee)=>{ //check if this is the only department they are a part of
						if(employee.name === value){
							departments++;
						}
					});
					break;
				}
			}
			if(currentMember && departments === 1){ //this is if they are only part of current department
				theState['onlyDepartment'] = true;
				theState['newDepartment'] = "Miscellaneous"; //arbitrary default department value
			}
		}
		theState[identity] = value;
		this.setState(theState);
	}

	componentDidMount(){ //when component mounts, retrieve list of all employees
		let employeeList=[];
		axios({
			method:'post',
			url: path,
			headers:{'Content-Type':'application/json'},
			data:{endpoint:'info',table:'users',action:'employees'}
		}).then((response)=>{
			let employeeList = response.data.data.map((employee)=>{
				return employee.name;
			});
			this.setState({employees:employeeList,department:this.props.departmentInfo[0].department,manager:this.props.departmentInfo[0].manager.name,departmentMembers:this.props.departmentInfo[0].employees});
		});
	}

	createDepartment(){ //method that handles the creation of a new department
		if(this.state.createDepartment.trim() !== '' && this.state.managerChoice !== 'Select' && this.props.departments.indexOf(this.state.createDepartment.trim()) === -1 && Validation("department",this.state.createDepartment.trim())){ //check to make sure all fields are filled out and contain valid input
			document.getElementById("createDepartment").style.borderColor="inherit";
			document.getElementById("manageLabel").style.color="inherit";
			let managerID;
			this.setState({loading:true,modalIsOpen:true});
			for(let i=0;i<this.props.employeeList.length;i++){ //get user ID for the manager of the new department
				if(this.state.managerChoice === this.props.employeeList[i].name){
					managerID = this.props.employeeList[i].userID;
					break;
				}
			}
			axios({ //create new department
				method:'post',
				url:path,
				headers:{'Content-Type':'application/json'},
				data:{endpoint:'create',table:'department',misc:'create',name:this.state.createDepartment.trim(),firstID:managerID}
			}).then((response)=>{
				this.setState({createDepartment:'',managerChoice:'Select',loading:false,modalPrompt:'Department Created!'});
			});
		}else{
			if(this.state.createDepartment.trim() === '' || !Validation("department",this.state.createDepartment.trim()) || this.props.departments.indexOf(this.state.createDepartment.trim()) !== -1){ //highlight new deparmtnet input field if it is empty, contains invalid characters, or already exists
				document.getElementById("createDepartment").style.borderColor="red";
				let message = '';
				if(this.props.departments.indexOf(this.state.createDepartment.trim()) !== -1){ //display error message
					message += "*department already exists.";
				}else if(!Validation("department",this.state.createDepartment.trim())){ //display error message
					message += "*must contain valid input.";
				}
				document.getElementById("createDeptSpan").innerHTML = message;
			}
			if(this.state.managerChoice === 'Select'){ //if no manager is selected for new department, highlight it in red
				document.getElementById("manageLabel").style.color="red";
			}
		}
	}

	render(){
		const customStyles = {
		  content : {
		    top: '50%',
		    left: '50%',
		    right: 'auto',
		    bottom: 'auto',
		    width:'100%',
		    minWidth:'300px',
		    maxWidth:'500px',
		    borderStyle:'solid',
		    borderWidth:'2px',
		    borderColor:'gray',
		    paddingTop:'10px',
		    transform: 'translate(-50%, -50%)',
		    boxShadow:'0.5px 0.5px 1px 0.5px'
			},  
			overlay:{
				backgroundColor:'rgba(105,105,105,0.8)'
			}
		};
		const buttonStyles ="br3 white b w-25-ns w-50-m w-100 h2 bg-navy shadow-2";
		const inputStyle = "pa2 br2 bw1 w-100-ns w-100 shadow-3";
		const selectStyles = "h2 pa1 w-100 br2 bw1 truncate shadow-3";
		let departmentInfo = this.props.departmentInfo;
		let employees = [];
		let currentManager;
		let otherDepartments = this.props.departments.filter((department)=>{ //get department options for dropdown menu
			return department !== this.state.department;
		});
		for(let i=0;i<this.props.departmentInfo.length;i++){ //get relevant information for the current department that has been selected
			if(this.props.departmentInfo[i].department === this.state.department){
				employees = this.props.departmentInfo[i].employees;
				currentManager = this.props.departmentInfo[i].manager.name;
			}
		}
		let modalContent;
		if(!this.state.loading){
			if(this.state.modalPrompt === ''){
				if(!this.state.newManager){ //modal content for moving employee to different department
					modalContent = <div>
									        <div className="fl w-100 tr">
									        	<button className="bg-white gray b br3" onClick={this.closeModal}>X</button>
									        </div>
								        	<div>
								        		<p className="navy b f5">Employee: <span className="black">{this.state.employeeToMove.name}</span></p>
								        	</div>
								        	<div className="pb1">
														<label className="navy b" id="newDeptLabel">New Department: <span id="newDeptSpan" className="red b">*</span></label>
													</div>
													<div className="pb3">
														<SelectBox identity="newDepartment" options={otherDepartments} styles={selectStyles} val={this.state.newDepartment} onSelect={this.handleInput}/>
													</div>
													<div className="w-100 center tc">
														<button className="br2 bg-navy b pa2 white" onClick={this.moveEmployee}>Move Employee</button>
													</div>
								        </div>;
				}else{ //modal content (confirmation) for selecting a new manager
					let departmentSelect;
					if(this.state.onlyDepartment){ //if new manager is only part of current department
						departmentSelect = <div>
																	<div className="pb1">
																		<label className="b navy" id="otherDept">Add To: </label>
																	</div>
																	<div>
																		<div className="pb3">
																			<SelectBox identity="newDepartment" options={otherDepartments} styles={selectStyles} val={this.state.newDepartment} onSelect={this.handleInput}/>
																		</div>
																	</div>
																</div>
					}
					modalContent = <div>
													<div className="fl w-100 tr">
									        	<button className="bg-white gray b br3" onClick={()=>{this.setState({modalIsOpen:false,newManager:false,onlyDepartment:false,manager:currentManager})}}>X</button>
									        </div>
									        {departmentSelect}
													<div>
														<p className="tc f4">Are you sure you would like to replace <span className="b navy">{currentManager}</span> with <span className="b navy">{this.state.manager}</span>?</p>
													</div>
													<div className="w-50-ns w-70-m w-100 center">
														<div className="fl w-50">
															<button onClick={this.newManager} className="tc br2 pa1 bg-dark-blue white b w-100">Yes</button>
														</div>
														<div className="fl w-50">
															<button className="tc br2 pa1 bg-dark-blue white b w-100" onClick={()=>{this.setState({modalIsOpen:false,newManager:false,onlyDepartment:false,manager:currentManager})}}>No</button>
														</div>
													</div>
												</div>
				}
			}else{ //modal prompt
				modalContent= <div>
												<div className="fl w-100 tr">
								        	<button className="bg-white gray b br3" onClick={this.closeModal}>X</button>
								        </div>
								        <div className="tc">
								        	<p className="navy b tc f4">{this.state.modalPrompt}</p>
								        </div>
											</div>
			}
		}else{ //loader gif
			modalContent = <div className="tc" style={{width:'150px',margin:'auto'}}><img src={loader} alt="Loading" /></div>;
		}
		let content;
		if(!this.props.create){ //this is the content for managing departments
			content = <div>
									<div className="w-60-ns w-75-m w-90 center">
										<div className="pb1">
											<label className="navy b">Department: </label>
										</div>
										<div className="pb3">
											<SelectBox identity="department" options={this.props.departments} styles={selectStyles} val={this.state.department} onSelect={this.handleInput}/>
										</div>
										<div className="pb1">
											<label className="navy b">Manager: </label>
										</div>
										<div className="pb3">
											<SelectBox identity="manager" options={this.state.employees} styles={selectStyles} val={this.state.manager} onSelect={this.handleInput}/>
										</div>
										<div className="tc pb1">
											<label className="navy b tc underline f4">Employees</label>
										</div>
										<div className="tc bg-white ba bw1 b--gray br2 pa1 shadow-3">
											<UnorderedList employees={employees} buttonClick={this.handleButtonClick}/>
										</div>
									</div>
									<div>
										<Modal
							          isOpen={this.state.modalIsOpen}
							          style={customStyles}
							          contentLabel="move department"
							          shouldCloseOnOverlayClick={false}
							          shouldCloseOnEsc={false}
							        >
							        {modalContent}
							      </Modal>
									</div>
								</div>
		}else{// this is the content for creating a new department
			content = <div className="w-40-ns w-60-m w-80 center pt2">
									<div className="pb1">
										<label id="deptLabel" className="b navy">Department name: <span id="createDeptSpan" className="red b">*Required</span></label>
									</div>
									<div className="pb3">
										<Input id="createDepartment" identity="createDepartment" type="text" onInput={this.handleInput} inputStyle={inputStyle} val={this.state.createDepartment}/>
									</div>
									<div className="pb1">
										<label id="manageLabel" className="b navy">Manager: <span id="createManagerSpan" className="red b">*Required</span></label>
									</div>
									<div className="pb3">
										<SelectBox identity="managerChoice" options={this.state.employees} styles={selectStyles} val={this.state.managerChoice} onSelect={this.handleInput}/>
									</div>
									<div className="w-100 center tc">
										<button className={buttonStyles} onClick={this.createDepartment}>Create</button>
									</div>
								</div>
		}
		return(
			<div>
				{content}
			</div>
		);
	}
}

const UnorderedList = props =>{ //functional unordered list component for listing the current members of each department

	let employees = props.employees.map((employee,i)=>{
		return (<li key={i} className="tl fl w-100 pa1 bb b--light-silver">
							<div className="pa1">
								<div className="fl w-70 pa1">
									<p className="ma0">{employee.name}</p>
								</div>
								<div className="fl w-30 pa1">
									<button id={employee.userID} name={employee.name} onClick={props.buttonClick} className="br2 bg-dark-blue white b">Switch Dept.</button>
								</div>
							</div>
						</li>);
	});
	return( <div>
						<ul className="list overflow-y-auto mt0 mb0 pl1 pr1" style={{maxHeight:'200px'}}>
							{employees}
						</ul>
					</div>
				);
};


// WEBPACK FOOTER //
// ./src/container/ManageDepartments.js